"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (state = [], action) => {
    if (action.experiences) {
        return [...state, ...action.experiences];
    }
    return state;
};
exports.getExperiences = (state) => state;
exports.getExperience = (state, id) => state.find((experience) => experience.id === id);
